/**
 * Copyright ©2026 Drivepoint
 */

import React from "react";
import DrivepointLogoInverse from "@assets/images/logos/drivepoint-logo-inverse.svg";
import DrivepointLogoPrimary from "@assets/images/logos/drivepoint-logo-primary.svg";
import "./AuthenticationLogo.css";

export type AuthenticationLogoProps = {
  className?: string;
  decorative?: boolean;
  tone: "inverse" | "primary";
};

export default function AuthenticationLogo(props: AuthenticationLogoProps): any {
  const logoSource = props.tone === "inverse" ? DrivepointLogoInverse : DrivepointLogoPrimary;
  const className = ["authentication-logo", props.className].filter(Boolean).join(" ");
  return <img
    className={className}
    src={logoSource}
    alt={props.decorative ? "" : "Drivepoint"}
    aria-hidden={props.decorative || undefined}
    draggable={false}
  />;
}
